/*
 * AQS mobile header reveal — NOLABEL-style.
 * On phones the logo/header bar hides while scrolling DOWN and slides back in
 * when scrolling UP, when scrolling STOPS (idle), or at the very TOP of the
 * page — always pinned flush to the top when shown. The announcement bar is
 * left alone (scrolls away with the page). Desktop is untouched.
 */
(function () {
  var header = document.querySelector('header-component');
  if (!header) return;

  var mq = window.matchMedia('(max-width: 749px)');
  var lastY = window.scrollY || window.pageYOffset || 0;
  var ticking = false;
  var idleTimer = null;
  var HIDDEN = 'aqs-header-hidden';

  function show() { header.classList.remove(HIDDEN); }
  function hide() { header.classList.add(HIDDEN); }

  function evaluate() {
    ticking = false;
    if (!mq.matches) { show(); return; }

    var y = window.scrollY || window.pageYOffset || 0;

    if (y <= 8) {
      show();                     // at the very top
    } else if (y > lastY + 4) {
      hide();                     // scrolling down
    } else if (y < lastY - 4) {
      show();                     // scrolling up
    }
    lastY = y;

    // Reveal again shortly after scrolling stops.
    if (idleTimer) clearTimeout(idleTimer);
    idleTimer = setTimeout(show, 200);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(evaluate);
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  // If the viewport crosses into desktop, make sure the header is visible.
  if (mq.addEventListener) {
    mq.addEventListener('change', function () { if (!mq.matches) show(); });
  }
})();
